export default "__VITE_PUBLIC_ASSET__f6b02dea__"